import cabecalho from '@/components/global/Cabecalho/Cabecalho.vue'
import menuLateral from '@/components/global/MenuLateral/MenuLateral.vue'
import Datefield from '@/components/layout/datefield/Datefield.vue'
import Timefield from '@/components/layout/timefield/Timefield.vue'
import UploadAvatar from '@/components/layout/uploadImagem/UploadAvatar.vue'
import { BToast, BSpinner } from 'bootstrap-vue'
import { mapActions, mapState } from 'vuex'
import mensagens from '@/util/mensagens'
import mascaras from '@/util/mascaras'
import util from '@/util'
import cadastroUtil from '@/util/cadastroUtil'
import Informacoes from '@/views/usuarios/Informacoes'

export default {
  name: 'cadastro-usuarios',
  components: {
    cabecalho,
    menuLateral,
    Datefield,
    Timefield,
    UploadAvatar,
    Informacoes,
    'b-toast': BToast,
    'b-spinner': BSpinner
  },

  computed: {
    ...mapState('usuarios', ['formulario', 'dadosRetorno', 'flagsDeControle', 'listaUnidadesDisponiveis'])
  },

  data: () => {
    return {
      comboEstados: [],
      comboTiposAcesso: [],
      comboUnidadesDisponiveis: [],
      diasSemanaOptions: [
        { valor: 'sunday', label: 'Dom' },
        { valor: 'monday', label: 'Seg' },
        { valor: 'tuesday', label: 'Ter' },
        { valor: 'wednesday', label: 'Qua' },
        { valor: 'thursday', label: 'Qui' },
        { valor: 'friday', label: 'Sex' },
        { valor: 'saturday', label: 'Sáb' }
      ],
      statusOptions: [
        { text: 'Sim', value: 1 },
        { text: 'Não', value: 0 }
      ],
      f_photo_usuario: null
    }
  },

  mounted () {
    this.ActionResetarDadosFormularioUsuario()
    this.ActionResetarDadosRetornoCadastro()
    this.obterTiposAcesso()
  },

  methods: {
    ...mapActions('usuarios', ['ActionResetarDadosFormularioUsuario', 'ActionDefinirListaUnidades', 'ActionResetarDadosRetornoCadastro']),

    async obterTiposAcesso () {
      try {
        const resposta = await this.axios.get('/usuarios/perfis')
        this.comboTiposAcesso = resposta.data.retorno.dados
      } catch (e) {
        this.comboTiposAcesso = []
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
    },

    async salvarRegistro () {
      this.definirFlagManipulandoDados(true, mensagens.salvandoDadosCadastro)

      let dadosFormulario = util.mapearObjetos(this.formulario, {})
      dadosFormulario.f_birthday = util.formatarData(dadosFormulario.f_birthday)
      dadosFormulario.f_office = cadastroUtil.obterCodigoCombo({ campo: dadosFormulario.f_office })
      dadosFormulario.f_areas = null
      dadosFormulario.f_profile_data = {}
      const formData = this.montarObjetoDeEnvio(dadosFormulario)

      let resposta = await this.axios.post('/usuarios/salvar', formData)
      this.dadosRetorno.sucesso = resposta.data.retorno.sucesso
      this.dadosRetorno.mensagem = resposta.data.retorno.mensagem
      this.dadosRetorno.listaDeErros = resposta.data.retorno.listaDeErros

      this.definirFlagManipulandoDados(false, '')
      this.tratarAposSalvarRegistro()
    },

    montarObjetoDeEnvio (dadosFormulario) {
      const formData = new FormData()
      const campos = Object.entries(dadosFormulario)

      const fotoUsuario = ['f_photo']
      const camposListas = ['f_daysweek', 'f_profile_data']
      const camposIgnorados = [...fotoUsuario, ...camposListas]

      for (let [chave, valor] of campos) {
        if (!camposIgnorados.includes(chave) && !util.valorVazio(valor)) {
          formData.append(chave, valor)
        }

        if (fotoUsuario.includes(chave) && !util.valorVazio(valor)) {
          formData.append(chave + '[]', valor, valor.nome)
        }

        if (camposListas.includes(chave) && !util.valorVazio(valor)) {
          formData.append(chave, JSON.stringify(valor))
        }
      }
      return formData
    },

    tratarAposSalvarRegistro () {
      if (this.dadosRetorno.sucesso) {
        this.$router.push({ name: 'usuarios' }).then(() => {
          util.criarAlertaToastDeSucesso(this, 'Aviso', 'Dados salvos com sucesso.')
        })
      } else {
        let mensagemRetorno = this.dadosRetorno.mensagem
        let flagNegociador = this.dadosRetorno.listaDeErros.flagConfigNegociador
        if (!util.valorVazio(flagNegociador)) {
          util.criarAlertaToastDeErro(this, 'Aviso', mensagemRetorno + '. ' + flagNegociador)
        } else {
          util.criarAlertaToastDeErro(this, 'Aviso', mensagemRetorno)
        }
      }
    },

    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    },

    definirFlagManipulandoDados (status, mensagem) {
      this.flagsDeControle.manipulandoDados.status = status
      this.flagsDeControle.manipulandoDados.mensagem = mensagem
    },

    getStatus (value) {
      switch (value) {
        case 1:
        case 2:
          return 1
        default:
          return 0
      }
    },

    mascaraTelefoneCelular (valor) {
      return mascaras.mascaraTelefoneCelular(valor)
    },

    receberDadosUploadAvatar (dadosArquivo) {
      this.formulario.f_photo = []
      this.formulario.f_photo = dadosArquivo
    }
  }
}
